import '../../styles/Common/Loader.scss';

const LoaderScreen = () => {
  return (
    <div className="loader">
      <Loader />
    </div>
  );
};

export const Loader = () => (
  <div className="circular-loader"></div>
);

export default LoaderScreen;
